export const SETTING = "SETTING"